import { ConfigService } from 'app/config/config.service';
import { z } from 'zod';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { Invitation, invitationSchema } from 'app/agriculture/queries/invitations/types/Invitation';

export async function getUserInvitations({
    queryKey: [endpoint, { email }],
}: {
    queryKey: [endpoint: string, { email: string }];
}) {
    const instance = createAxiosInstance();
    const { data } = await instance.get<unknown>(
        `${ConfigService.apiUrlRoot}agriculture${endpoint}`,
        { params: { email, status: 'Pending' } },
    );

    return z.array(invitationSchema).parse(data) as Invitation[];
}
